/**
 * Text-to-speech client. POSTs assistant prose to the backend and returns the
 * raw Response (audio/mpeg). The caller reads `.blob()` or streams `.body`.
 */
import { getValidAccessTokenFromStorage } from "@weco/suite-client";

const SPEAK_ENDPOINT = "/api/assistant/voice/speak/";

export async function synthesizeSpeech(
  text: string,
  opts: { voice?: string; locale?: string; stream?: boolean; signal?: AbortSignal } = {},
): Promise<Response> {
  const token = await getValidAccessTokenFromStorage();
  const resp = await fetch(SPEAK_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      text,
      voice: opts.voice ?? "",
      locale: opts.locale ?? "",
      stream: Boolean(opts.stream),
    }),
    signal: opts.signal,
  });

  if (!resp.ok) {
    let msg = `Speech failed (${resp.status})`;
    try {
      const body = await resp.json();
      if (body?.error) msg = typeof body.error === "string" ? body.error : msg;
    } catch {
      /* ignore */
    }
    throw new Error(msg);
  }
  return resp;
}
